import { template } from "@ember/template-compiler";
import { INSURANCE_TYPES } from 'client-portal/models/waitlist-intake-form';
import { eq } from 'ember-truth-helpers';
import { fn } from '@ember/helper';
import { on } from '@ember/modifier';
import Component from '@glimmer/component';
import RequestValidatedInput from 'client-portal/components/request/validated-input';
import t from 'ember-intl/helpers/t';
export default class SiteWaitlistIntakeFormInsuranceType extends Component {
    insuranceTypes = INSURANCE_TYPES;
    static{
        template(`
    <div class="row">
      <div class="col-12" data-test-insurance-type>
        <label class="required">
          {{t "site.waitlistIntake.fields.insuranceType"}}
        </label>
        <RequestValidatedInput
          @model={{@form}}
          @path="insuranceType"
          @isDirty={{@form.isDirty}}
          @classNames="block"
        >
          <div class="insurance-options">
            <label class="boolean" for="waitlist-insurance-self-pay">
              <input
                type="radio"
                id="waitlist-insurance-self-pay"
                name="insuranceType"
                checked={{eq @form.insuranceType this.insuranceTypes.SELF_PAY}}
                {{on "change" (fn @onUpdate "insuranceType" this.insuranceTypes.SELF_PAY)}}
                data-test-insurance-type="self-pay"
              />
              {{t "site.waitlistIntake.insuranceTypes.selfPay"}}
            </label>
            <label class="boolean" for="waitlist-insurance-insurance">
              <input
                type="radio"
                id="waitlist-insurance-insurance"
                name="insuranceType"
                checked={{eq @form.insuranceType this.insuranceTypes.INSURANCE}}
                {{on "change" (fn @onUpdate "insuranceType" this.insuranceTypes.INSURANCE)}}
                data-test-insurance-type="insurance"
              />
              {{t "site.waitlistIntake.insuranceTypes.insurance"}}
            </label>
          </div>
        </RequestValidatedInput>
      </div>
    </div>
  `, {
            component: this,
            eval () {
                return eval(arguments[0]);
            }
        });
    }
}
